import { blogLanguagesWithRtl as languages } from '@wix/communities-blog-universal/dist/src/constants/blog-languages';

export const validateLanguage = language => (languages.includes(language) ? language : 'en');
